import styled from "styled-components";

export const TextEditorWrapper = styled.div`
  border: 1px solid #e3e6e8;
  border-radius: 4px;
  margin-bottom: 7px;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: #f2f2f2;
  }
`;

export const teaserTextStyle = {
  fontSize: "15px",
  lineHeight: "19px"
};
